import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Globe2, Users, MapPin, CalendarDays, ArrowRight } from "lucide-react";

/**
 * TourManagementSection — React + Tailwind + Framer Motion
 */
function TourManagementSection() {
    const { t } = useTranslation();
    const services = [
        {
            icon: <Globe2 className="h-8 w-8" />,
            title: t('tour_1_title'),
            desc: t('tour_1_desc'),
        },
        {
            icon: <Users className="h-8 w-8" />,
            title: t('tour_2_title'),
            desc: t('tour_2_desc'),
        },
        {
            icon: <MapPin className="h-8 w-8" />,
            title: t('tour_3_title'),
            desc: t('tour_3_desc'),
        },
        {
            icon: <CalendarDays className="h-8 w-8" />,
            title: t('tour_4_title'),
            desc: t('tour_4_desc'),
        },
    ];

    return (
        <section className="relative bg-gradient-to-br from-green-700 via-green-800 to-green-900 text-white py-20">
            <div className="absolute -top-24 -right-24 w-80 h-80 bg-green-500/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-32 -left-24 w-80 h-80 bg-green-400/20 rounded-full blur-3xl" />

            <div className="relative max-w-6xl mx-auto px-6">
                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-14"
                >
                    <h2 className="text-3xl md:text-5xl font-extrabold mb-4">
                        {t('label_tour')}
                    </h2>
                    <p className="text-blue-100/90 max-w-2xl mx-auto">
                        {t('desc_tour')}
                    </p>
                </motion.div>

                {/* Services Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {services.map((srv, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 hover:bg-white/15 transition shadow-md"
                        >
                            <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-white/15 mb-5">
                                {srv.icon}
                            </div>
                            <h3 className="text-xl font-semibold mb-3">{srv.title}</h3>
                            {/* <p className="text-blue-100/90 text-sm leading-relaxed">{srv.desc}</p> */}
                        </motion.div>
                    ))}
                </div>

                {/* CTA */}
                {/* <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.45, delay: 0.3 }}
                    className="mt-12 flex justify-center"
                >
                    <button className="inline-flex items-center gap-2 rounded-2xl bg-white text-blue-900 font-semibold px-6 py-3 shadow-md hover:shadow-lg hover:bg-blue-50 active:scale-[0.98] transition">
                        Learn More
                        <ArrowRight className="h-5 w-5" />
                    </button>
                </motion.div> */}
            </div>
        </section>
    );
}

export default TourManagementSection;